import "@/App.css";
import { BrowserRouter, Routes, Route, Link, Navigate } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import Club from "@/pages/Club";
import Histoire from "@/pages/Histoire";
import Equipes from "@/pages/Equipes";
import TeamDetail from "@/pages/TeamDetail";
import Actualites from "@/pages/Actualites";
import ArticleDetail from "@/pages/ArticleDetail";
import Calendrier from "@/pages/Calendrier";
import Resultats from "@/pages/Resultats";
import Projets from "@/pages/Projets";
import ProjetSportif from "@/pages/ProjetSportif";
import Senegal from "@/pages/Senegal";
import Partenaires from "@/pages/Partenaires";
import Contact from "@/pages/Contact";
import { MentionsLegales, PolitiqueConfidentialite } from "@/pages/Legal";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import { PaiementConfirme, PaiementAnnule } from "@/pages/PaiementRetour";
import Rejoindre, { InscriptionConfirme, InscriptionAnnule } from "@/pages/Rejoindre";
import EspaceHome from "@/pages/espace/EspaceHome";
import EspaceLogin from "@/pages/espace/EspaceLogin";
import EspaceMotDePasseOublie from "@/pages/espace/EspaceMotDePasseOublie";
import EspaceCreerAcces from "@/pages/espace/EspaceCreerAcces";
import { EspaceReinitialiser, EspaceDefinirMotDePasse } from "@/pages/espace/EspaceSetPassword";
import EspaceDashboard from "@/pages/espace/EspaceDashboard";

function NotFound() {
  return (
    <div className="min-h-screen bg-navy flex flex-col items-center justify-center px-5 text-center">
      <p className="font-heading font-semibold uppercase tracking-tighter text-outline-white text-[30vw] sm:text-[12rem] leading-none select-none">404</p>
      <p className="text-white/70 -mt-4 sm:-mt-8">Cette page a quitté le peloton.</p>
      <Link
        to="/"
        className="mt-8 inline-flex items-center gap-3 bg-rouge text-white font-heading uppercase tracking-wider text-sm px-8 py-4 hover:bg-white hover:text-navy transition-[background-color,color] duration-300"
      >
        Retour à l'accueil
      </Link>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/le-club" element={<Club />} />
              <Route path="/le-club/projet-sportif" element={<Navigate to="/projets/projet-sportif" replace />} />
              <Route path="/histoire" element={<Histoire />} />
              <Route path="/equipes" element={<Equipes />} />
              <Route path="/equipes/:slug" element={<TeamDetail />} />
              <Route path="/actualites" element={<Actualites />} />
              <Route path="/actualites/:slug" element={<ArticleDetail />} />
              <Route path="/calendrier" element={<Calendrier />} />
              <Route path="/resultats" element={<Resultats />} />
              <Route path="/projets" element={<Projets />} />
              <Route path="/projets/projet-sportif" element={<ProjetSportif />} />
              <Route path="/projets/senegal" element={<Senegal />} />
              <Route path="/partenaires" element={<Partenaires />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
              <Route path="/partenaires/paiement/confirme" element={<PaiementConfirme />} />
              <Route path="/partenaires/paiement/annule" element={<PaiementAnnule />} />
              <Route path="/rejoindre" element={<Rejoindre />} />
              <Route path="/rejoindre/confirmation" element={<InscriptionConfirme />} />
              <Route path="/rejoindre/annule" element={<InscriptionAnnule />} />
              <Route path="/espace" element={<EspaceHome />} />
              <Route path="/espace/connexion" element={<EspaceLogin />} />
              <Route path="/espace/mot-de-passe-oublie" element={<EspaceMotDePasseOublie />} />
              <Route path="/espace/creer-acces" element={<EspaceCreerAcces />} />
              <Route path="/espace/reinitialiser" element={<EspaceReinitialiser />} />
              <Route path="/espace/definir-mot-de-passe" element={<EspaceDefinirMotDePasse />} />
              <Route path="/espace/tableau-de-bord" element={<EspaceDashboard />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Toaster richColors position="top-right" />
        </ReactLenis>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
